import React from 'react';
import {
  Box,
  Container,
  Stack,
  Text,
  Link,
  useColorModeValue,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

export default function Footer() {
  return (
    <Box
      bg={useColorModeValue('gray.50', 'gray.900')}
      color={useColorModeValue('gray.700', 'gray.200')}
      mt={10}
    >
      <Container
        as={Stack}
        maxW={'6xl'}
        py={4}
        spacing={4}
        justify={'center'}
        align={'center'}
      >
        <Text fontSize="2xl" fontWeight="bold" color="brand.500">
          MCPpm
        </Text>
        <Stack direction={'row'} spacing={6}>
          <Link as={RouterLink} to={'/'}>
            Home
          </Link>
          <Link as={RouterLink} to={'/packages'}>
            Packages
          </Link>
          <Link as={RouterLink} to={'/about'}>
            About
          </Link>
          <Link as={RouterLink} to={'/docs'}>
            Documentation
          </Link>
        </Stack>
      </Container>

      <Box
        borderTopWidth={1}
        borderStyle={'solid'}
        borderColor={useColorModeValue('gray.200', 'gray.700')}
      >
        <Container
          as={Stack}
          maxW={'6xl'}
          py={4}
          direction={{ base: 'column', md: 'row' }}
          spacing={4}
          justify={{ base: 'center', md: 'space-between' }}
          align={{ base: 'center', md: 'center' }}
        >
          <Text>© {new Date().getFullYear()} MCPpm. All rights reserved</Text>
          <Stack direction={'row'} spacing={6}>
            <Link href={'https://github.com/ZXHSZ/mcppm'} isExternal>
              GitHub
            </Link>
            <Link href={'#'}>Privacy</Link>
            <Link href={'#'}>Terms</Link>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
}
